<div class="container-fluid mt-4">
  <div class="row">

    <!-- Filter Auditors -->
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-between">
            <h5 class="font-medium m-0">Audit Management</h5>
            
          </div>
          <div class="d-flex align-items-end gap-2">
              <button type="button" class="btn btn-info btn-sm" data-bs-toggle="modal"
                data-bs-target="#AuditAddMember"><i class="bi bi-plus-square-dotted"></i> Add Member</button>
              <button type="button" class="btn btn-info btn-sm" data-bs-toggle="modal" data-bs-target="#AddAuditDate"><i
                  class="bi bi-plus-square-dotted"></i>Add Audit Date</button>
              <!-- <div class="upload-csv-btn file btn btn-sm btn-primary" >
                <i class="bi bi-box-arrow-in-down"></i> Upload CSV
                <input type="file" name="file" />
              </div> -->
            </div>
          <!-- Add Member Modal -->
          <div class="modal fade" id="AuditAddMember" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
            aria-labelledby="AuditAddMemberLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="AuditAddMemberLabel">Add Member</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="resetForm()"
                    aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <form #auditorForm="ngForm" (ngSubmit)="submitAuditorForm(auditorForm)">
                    <div class="row">
                      <!-- Type of Auditor -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="auditorType" class="form-label">Type of Auditor <span
                            class="text-danger">*</span></label>
                        <select class="form-control" [(ngModel)]="newAuditor.roleId" id="auditorType" name="auditorType"
                          required>
                          <option value="" disabled selected>Select Auditor</option>
                          <option *ngFor="let auditor of auditors" [value]="auditor.id">
                            {{ auditor.name }}
                          </option>
                        </select>
                        <div
                          *ngIf="auditorForm.controls['auditorType']?.invalid && auditorForm.controls['auditorType']?.touched"
                          class="text-danger">
                          Auditor Type is required.
                        </div>
                      </div>

                      <!-- Name -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="name" class="form-label">Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="newAuditor.name" placeholder="Enter Name"
                          id="name" name="name" required minlength="3" pattern="^[A-Za-z ]+$" />
                        <div *ngIf="auditorForm.controls['name']?.invalid && auditorForm.controls['name']?.touched"
                          class="text-danger">
                          <div *ngIf="auditorForm.controls['name']?.errors?.['required']">
                            Name is required.
                          </div>
                          <div *ngIf="auditorForm.controls['name']?.errors?.['minlength']">
                            Name must be at least 3 characters long.
                          </div>
                          <div *ngIf="auditorForm.controls['name']?.errors?.['pattern']">
                            Name must contain only alphabets.
                          </div>
                        </div>

                      </div>

                      <!-- Mobile Number -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="mobile" class="form-label">Mobile No <span class="text-danger">*</span></label>

                        <input type="tel" class="form-control" id="mobile" name="mobile" [(ngModel)]="newAuditor.mobile"
                          #mobileRef="ngModel" required pattern="^[6-9][0-9]{9}$" placeholder="Enter Mobile Number"
                          maxlength="10" />


                        <!-- Validation Error Messages -->
                        <div *ngIf="mobileRef.invalid && mobileRef.touched" class="text-danger">
                          <div *ngIf="mobileRef.errors?.['required']">Mobile No. is required.</div>
                          <div *ngIf="mobileRef.errors?.['pattern']">Enter a valid 10-digit mobile number.</div>
                        </div>
                      </div>


                      <!-- Email -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="email" class="form-label">Email Id <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="newAuditor.emailID" name="email" id="email"
                          placeholder="Enter email id" required
                          pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$" />
                        <div *ngIf="auditorForm.controls['email']?.invalid && auditorForm.controls['email']?.touched"
                          class="text-danger">
                          <div *ngIf="auditorForm.controls['email']?.errors?.['required']">
                            Email is required.
                          </div>
                          <div *ngIf="auditorForm.controls['email']?.errors?.['pattern']">
                            A valid email is required.
                          </div>
                        </div>
                      </div>
                      <!-- Category of the Firm -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="category" class="form-label">Category of the firm <span
                            class="text-danger">*</span></label>
                        <select class="form-control" [(ngModel)]="newAuditor.categoryID" id="category" name="category"
                          required>
                          <option value="" selected>Select Category</option>
                          <option *ngFor="let category of categories" [value]="category.id">
                            {{ category.name }}
                          </option>
                        </select>
                        <div
                          *ngIf="auditorForm.controls['category']?.invalid && auditorForm.controls['category']?.touched"
                          class="text-danger">
                          Category is required.
                        </div>
                      </div>

                      <!-- Certificate of Practice -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="certificate" class="form-label">Certificate of Practice <span
                            class="text-danger">*</span></label>
                

                              <input type="file" class="form-control" (change)="onFileChange($event)" id="certificate"
                        name="sUploadMomAGM" accept=".jpg, .jpeg, .png, .pdf" [(ngModel)]="newAuditor.certificateOfPractice"
                        required />
                        <div
                          *ngIf="auditorForm.controls['certificate']?.invalid && auditorForm.controls['certificate']?.touched"
                          class="text-danger">
                          Certificate of Practice is required (min 5 characters).
                        </div>
                      </div>

                      

                      <!-- Firm Registration No -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="firmRegistration" class="form-label">Registration No. <span
                            class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="newAuditor.firmRegistrationNo"
                          placeholder="Firm Registration No." id="firmRegistration" name="firmRegistration" required />
                        <div
                          *ngIf="auditorForm.controls['firmRegistration']?.invalid && auditorForm.controls['firmRegistration']?.touched"
                          class="text-danger">
                           Registration No. is required.
                        </div>
                      </div>

                      <!-- Total Audit Conducted -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="totalAudit" class="form-label">Total Audit Conducted in FY <span
                            class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="newAuditor.totalAuditFY"
                          placeholder="Total Audit Conducted in FY" id="totalAudit" name="totalAudit" required
                          min="0" />
                        <div
                          *ngIf="auditorForm.controls['totalAudit']?.invalid && auditorForm.controls['totalAudit']?.touched"
                          class="text-danger">
                          Total Audit is required (must be a number greater than or equal to 0).
                        </div>
                      </div>

                      <!-- Detail Audit Conducted -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="detailAudit" class="form-label">Details of Audit Conducted <span
                            class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="newAuditor.detailAudit"
                          placeholder="Details of Audit Conducted" id="detailAudit" name="detailAudit" required />
                        <div
                          *ngIf="auditorForm.controls['detailAudit']?.invalid && auditorForm.controls['detailAudit']?.touched"
                          class="text-danger">
                          Details of Audit is required.
                        </div>
                      </div>

                      <!-- District -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="district" class="form-label">District <span class="text-danger">*</span></label>
                        <select class="form-control" [(ngModel)]="newAuditor.districtId" id="district" name="district"
                          required>
                          <option value="" selected>Select District</option>
                          <option *ngFor="let dist of districts" [value]="dist.id">
                            {{ dist.name }}
                          </option>
                        </select>
                        <div
                          *ngIf="auditorForm.controls['district']?.invalid && auditorForm.controls['district']?.touched"
                          class="text-danger">
                          District is required.
                        </div>
                      </div>

                      <!-- Address -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="address" class="form-label">Head Office Address <span
                            class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="newAuditor.headOfficeAddress"
                          placeholder="Enter Full Address" id="address" name="address" required minlength="10" />
                        <div
                          *ngIf="auditorForm.controls['address']?.invalid && auditorForm.controls['address']?.touched"
                          class="text-danger">
                          Address is required (min 10 characters).
                        </div>
                      </div>
                      <!-- Address -->
                      <div class="col-lg-4 col-md-6 mb-2">
                        <label for="password" class="form-label">Password <span class="text-danger">*</span></label>
                        <input type="password" class="form-control" [(ngModel)]="newAuditor.password"
                          placeholder="Enter Password" id="password" name="password" required
                          pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*?&]{6,}$" />
                        <div
                          *ngIf="auditorForm.controls['password']?.invalid && auditorForm.controls['password']?.touched"
                          class="text-danger">
                          <div *ngIf="auditorForm.controls['password']?.errors?.['required']">
                            Password is required.
                          </div>
                          <div *ngIf="auditorForm.controls['password']?.errors?.['pattern']">
                            Password must be at least 6 characters, include letters and numbers.
                          </div>
                        </div>

                      </div>
                    </div>

                    <div class="modal-footer">
                      <button type="submit" class="btn btn-primary" data-bs-dismiss="modal"
                        [disabled]="auditorForm.invalid">Submit</button>
                      <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row align-items-end">
            <!-- Type of Auditor Filter -->
            <div class="col-lg-3 col-md-6 mb-2">
              <label for="filterType" class="form-label">Type of Auditor</label>
              <select class="form-control" [(ngModel)]="filter.auditortype" id="auditortype" name="auditortype"
                (change)="search()">
                <option value="" selected>Select Auditor</option>
                <option *ngFor="let auditor of auditors" [value]="auditor.name">
                  {{ auditor.name }}
                </option>
              </select>
            </div>

            <!-- District Filter -->
            <div class="col-lg-3 col-md-6 mb-2">
              <label for="filterDistrict" class="form-label">District</label>
              <select class="form-control" id="district" [(ngModel)]="filter.district" name="district"
                (change)="search()">
                <option value="" selected>Select District</option>
                <option *ngFor="let dist of districts" [value]="dist.name">
                  {{ dist.name }}
                </option>
              </select>
            </div>

            <!-- Keyword Filter -->
            <div class="col-lg-3 col-md-6 mb-2">
              <label for="keyword" class="form-label">Any Keywords</label>
              <input class="form-control" [(ngModel)]="filter.keyword" (keyup)="search()"
                placeholder="Enter Any Keywords" id="keyword" />
            </div>

            <!-- Search Button -->
            <div class="col-lg-3 col-md-6 text-end">
              <button type="button" class="btn btn-primary" (click)="search()"><i class="bi bi-search"></i>
                Search</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <!-- Pagination controls -->
          <div class="pagination-controls"
            style="display: flex; justify-content: flex-end; align-items: center; width: 100%;">
            <div class="pagination-right" style="display: flex; align-items: center;">
              <label for="rowsPerPage" style="margin-right: 8px;">Display Data:</label>
              <select id="rowsPerPage" [(ngModel)]="page.pageSize" (change)="onRowsPerPageChange()"
                style="padding: 5px; font-size: 14px;">

                <option *ngFor="let size of [10, 20, 50, 100]" [value]="size">{{size}}</option>
              </select>
            </div>
          </div>
          <br />



          <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover" [rows]="rows"
            [columns]="columns" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
            [externalPaging]="true" [count]="page.totalRecords" [offset]="page.pageNumber" [limit]="page.pageSize"
            (page)="setPage($event)" [virtualization]="false" [scrollbarV]="false" [scrollbarH]="true"
            [loadingIndicator]="loading">
            <!-- S.No. Column -->
            <ngx-datatable-column name="#" [sortable]="false">
              <ng-template let-rowIndex="rowIndex" let-value="value" ngx-datatable-cell-template>
                <span>{{(page.pageNumber-0)*page.pageSize+rowIndex+1}}</span>
              </ng-template>
            </ngx-datatable-column>

            <!-- Dynamic Columns -->
            <ngx-datatable-column *ngFor="let column of columns" [sortable]="true" [name]="column.name"
              [prop]="column.prop">
              <ng-template ngx-datatable-cell-template let-row="row" let-value="value">
                {{ value }}
              </ng-template>
            </ngx-datatable-column>

            <!-- Action Column -->
            <ngx-datatable-column name="Action" [sortable]="false">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <button type="button" class="btn btn-info btn-sm" (click)="loadAuditors(row.id)" data-bs-toggle="modal"
                  data-bs-target="#AuditViewMember">
                  <i class="bi bi-person-vcard"></i>
                </button>
                &nbsp;
                <button type="button" class="btn btn-danger btn-sm" (click)="openDeleteModal(row.id)"
                  data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                  <i class="bi bi-trash3"></i>
                </button>
              </ng-template>
            </ngx-datatable-column>

          </ngx-datatable>
        </div>
      </div>
    </div>

  </div>
</div>
<!-- Modal to View Auditor Details -->

<div class="modal fade" id="AuditViewMember" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="AuditViewMemberLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered  modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="AuditViewMemberLabel">Name of the Auditor</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="row" *ngFor="let filtered of filteredData">
          <!-- Type of Auditor -->
          <div class="col-md-6 mb-2">
            <label for="viewAuditType" class="form-label">Type of Auditor</label>
            <input type="text" class="form-control" [value]="filtered?.auditortype" disabled />
          </div>

          <!-- District -->
          <div class="col-md-6 mb-2">
            <label for="viewDistrict" class="form-label">District</label>
            <input type="text" class="form-control" [value]="filtered?.sDistrictName" disabled />
          </div>

          <!-- Mobile No -->
          <div class="col-md-6 mb-2">
            <label for="viewMobile" class="form-label">Mobile No</label>
            <input type="text" class="form-control" [value]="filtered?.mobile" disabled />
          </div>

          <!-- Email Id -->
          <div class="col-md-6 mb-2">
            <label for="viewEmail" class="form-label">Email Id</label>
            <input type="text" class="form-control" [value]="filtered?.emailID" disabled />
          </div>

          <!-- Category of the Firm -->
          <div class="col-md-6 mb-2">
            <label for="viewCategory" class="form-label">Category of the Firm</label>
            <input type="text" class="form-control" [value]="filtered?.category" disabled />
          </div>

          <!-- Firm Registration No -->
          <div class="col-md-6 mb-2">
            <label for="viewFirmRegistration" class="form-label">Firm Registration No</label>
            <input type="text" class="form-control" [value]="filtered?.firmRegistrationNo" disabled />
          </div>

          <!-- Certificate of Practice -->
          <div class="col-md-6 mb-2">
            <label for="viewCertificate" class="form-label">Certificate of Practice</label>
            <input type="text" class="form-control" [value]="filtered?.certificateOfPractice" disabled />
          </div>

          <!-- Total Audit Conducted -->
          <div class="col-md-6 mb-2">
            <label for="viewTotalAudit" class="form-label">Total Audit Conducted</label>
            <input type="text" class="form-control" [value]="filtered?.totalAuditFY" disabled />
          </div>

          <!-- Details of Audit Conducted -->
          <div class="col-md-6 mb-2">
            <label for="viewAuditDetails" class="form-label">Details of Audit Conducted</label>
            <input type="text" class="form-control" [value]="filtered?.detailAudit" disabled />
          </div>

          <!-- Head Office Address -->
          <div class="col-md-6 mb-2">
            <label for="viewAddress" class="form-label">Head Office Address</label>
            <input type="text" class="form-control" [value]="filtered?.headOfficeAddress" disabled />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
<!-- Delete Confirmation Modal -->
<div class="modal fade" id="exampleModalCenter" tabindex="-1" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalCenterTitle">Delete Audit</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Are you sure you want to delete this audit?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger" data-bs-dismiss="modal" (click)="confirmDelete()">Delete</button>

      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="AddAuditDate" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-labelledby="AuditAddMemberLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="AddAuditDateLabel">Assign Audit Date</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="resetForm();resetAuditDetailsForm()"
          aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="auditDateForm">
          <div class="row">
            <div class="col-lg-4 col-md-6 mb-2">
              <label for="name" class="form-label">Select Role</label>
              <select id="rowsPerPage" class="form-control" formControlName="role" (change)="onRoleChange($event)">
                <option value="" disabled selected>Select Role</option>
                <option value="1">Society</option>
                <option value="2">Assistant Registrar</option>
              </select>
              <div *ngIf="auditDateForm.controls['role']?.invalid && auditDateForm.controls['role']?.touched"
                class="text-danger">
                Please Select Role.
              </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-2" *ngIf="auditDateForm.controls['role'].value==1">
              <label for="name" class="form-label">Society Audit Start Date<span class="text-danger">*</span></label>
              <input type="date" class="form-control" placeholder="Select Date" id="date" name="date"
                formControlName="sAuditStartDate" [readonly]="true" />
              <div
                *ngIf="auditDateForm.controls['sAuditStartDate']?.invalid && auditDateForm.controls['sAuditStartDate']?.touched"
                class="text-danger">
                Society Audit Start Date required.
              </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-2" *ngIf="auditDateForm.controls['role'].value==1">
              <label for="name" class="form-label">Society Audit End Date<span class="text-danger">*</span></label>
              <input type="date" class="form-control" placeholder="Select Date" id="date" name="date"
                formControlName="sAuditEndDate" />
              <div
                *ngIf="auditDateForm.controls['sAuditEndDate']?.invalid && auditDateForm.controls['sAuditEndDate']?.touched"
                class="text-danger">
                Society Audit End Date required.
              </div>

            </div>
            <div class="col-lg-4 col-md-6 mb-2" *ngIf="auditDateForm.controls['role'].value==2">
              <label for="name" class="form-label">AR Audit Start Date<span class="text-danger">*</span></label>
              <input type="date" class="form-control" placeholder="Select Date" id="date" name="date"
                formControlName="arAuditStartDate" [readonly]="true" />
              <div
                *ngIf="auditDateForm.controls['arAuditStartDate']?.invalid && auditDateForm.controls['arAuditStartDate']?.touched"
                class="text-danger">
                AR Audit Start Date required.
              </div>
            </div>
            <div class="col-lg-4 col-md-6 mb-2" *ngIf="auditDateForm.controls['role'].value==2">
              <label for="name" class="form-label">AR Audit End Date<span class="text-danger">*</span></label>
              <input type="date" class="form-control" placeholder="Select Date" id="date" name="date"
                formControlName="arAuditEndDate" />
              <div
                *ngIf="auditDateForm.controls['arAuditEndDate']?.invalid && auditDateForm.controls['arAuditEndDate']?.touched"
                class="text-danger">
                AR Audit End Date required.
              </div>
            </div>

          </div>

          <div class="modal-footer">
            <button type="submit" class="btn btn-primary" data-bs-dismiss="modal" [disabled]="auditDateForm.invalid"
              (click)="assignAuditDate()">Submit</button>

          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<span class="text-danger">*</span>